import React from 'react'
import Header from './Header'
import Sidebar from './Sidebar'
import { Box } from '@mui/material'

export default function Layout({ title, active, children }) {
  return (
    <main>
      <div className="pageWrapper d-lg-flex">
        {/********Sidebar**********/}
          <aside className="sidebarArea shadow" id="sidebarArea">
            <Sidebar active={active} />
          </aside>
        {/********Content Area**********/}
        <div className="contentArea">
          <Header title={title} />
          {children}
        </div>
      </div>
    </main>
  )
}
